<template>
  <div class="temporal-token-exchange">
    <div v-if="loading">Exchanging token...</div>
    <div v-else-if="error">{{ error }}</div>
    <div v-else>Redirecting...</div>
  </div>
</template>

<script>
  import axios from 'axios';
  import { setAccessToken, setRefreshToken } from 'src/services/session'; // adjust path if needed

  export default {
    name: 'TemporalTokenExchange',
    data() {
      return {
        loading: true,
        error: null,
      };
    },
    created() {
      this.exchangeTemporalToken();
    },
    methods: {
      async exchangeTemporalToken() {
        const token = this.$route.query['temporal-token'];
        const { error } = this.$route.query;

        if (error) {
          this.error = this.$t?.('pages.login.error') || 'Error logging in.';
          this.loading = false;
          return;
        }

        if (!token) {
          this.error = this.$t?.('pages.login.missingTemporalToken') || 'Missing temporal token.';
          this.loading = false;
          return;
        }

        try {
          const data = await axios.post('/api/temporal-tokens/exchange', { token });

          // Save tokens using your auth utility
          setAccessToken(data.access_token);
          setRefreshToken(data.refresh_token);

          const { redirect } = this.$route.query;
          this.$router.push(redirect || { name: 'dashboard' });
        } catch (err) {
          console.error(err);
          this.$router.push({ name: 'login' });
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>

<style scoped>
  .temporal-token-exchange {
    text-align: center;
    padding: 2rem;
  }
</style>
